import React from 'react';
import './Terms.css';

const Terms = () => {
  return (
    <div className="terms-container">
      <h1>Conditions d'Utilisation</h1>
      
      <section className="terms-section">
        <h2>Acceptation des Conditions</h2>
        <p>
          En utilisant notre application, vous acceptez d'être lié par ces conditions d'utilisation. 
          Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser notre service.
        </p>
      </section>

      <section className="terms-section">
        <h2>Description du Service</h2>
        <p>
          Ciné Séries App est une plateforme sociale permettant aux utilisateurs de :
        </p>
        <ul>
          <li>Noter et commenter des films et séries</li>
          <li>Créer et gérer des listes de visionnage</li>
          <li>Recevoir des recommandations personnalisées</li>
          <li>Interagir avec d'autres utilisateurs</li>
        </ul>
      </section>

      <section className="terms-section">
        <h2>Compte Utilisateur</h2>
        <p>
          Pour utiliser certaines fonctionnalités de Ciné Séries App, vous devez créer un compte. Vous êtes responsable de :
        </p>
        <ul>
          <li>Maintenir la confidentialité de votre mot de passe</li>
          <li>Toutes les activités effectuées sous votre compte</li>
        </ul>
      </section>

      <section className="terms-section">
        <h2>Contenu Utilisateur</h2>
        <p>
          En publiant du contenu sur FilmsRanker, vous :
        </p>
        <ul>
          <li>Conservez vos droits sur votre contenu</li>
          <li>Accordez à FilmsRanker une licence pour utiliser ce contenu</li>
          <li>Garantissez que votre contenu ne viole pas les droits des tiers</li>
        </ul>
      </section>

      <section className="terms-section">
        <h2>Règles de Conduite</h2>
        <p>
          Les utilisateurs doivent :
        </p>
        <ul>
          <li>Respecter les autres utilisateurs</li>
          <li>Ne pas publier de contenu offensant ou inapproprié</li>
          <li>Ne pas utiliser le service à des fins illégales</li>
          <li>Ne pas tenter de perturber le fonctionnement du service</li>
        </ul>
      </section>

      <section className="terms-section">
        <h2>Propriété Intellectuelle</h2>
        <p>
          Tous les droits de propriété intellectuelle relatifs au service Ciné Séries App sont réservés. 
          Les utilisateurs ne peuvent pas copier, modifier ou distribuer le contenu du service sans autorisation.
        </p>
      </section>

      <section className="terms-section">
        <h2>Modifications des Conditions</h2>
        <p>
          Ciné Séries App se réserve le droit de modifier ces conditions à tout moment. 
          Les utilisateurs seront informés des changements importants par email ou via le service.
        </p>
      </section>

      <section className="terms-section">
        <h2>Contact</h2>
        <p>
          Pour toute question concernant ces conditions d'utilisation, 
          vous pouvez nous contacter via le formulaire de support.
        </p>
      </section>

      <div className="footer-links">
        <a href="/support">Support</a>
        <a href="/privacy">Politique de confidentialité</a>
      </div>
    </div>
  );
};

export default Terms;
